import useSWR from "swr";
import fetcher from "./fetcher";

export default function useGetPaidAdminInvoiceItems(invoiceId) {
  const url = invoiceId
    ? `/api/talentDashboard/getPaidV2/admin/invoice/${invoiceId}/items`
    : null;

  const { data, error, mutate } = useSWR(url, fetcher);

  return {
    items: data?.items ?? [],
    raw: data?.raw ?? [],
    isLoading: Boolean(invoiceId) && !data && !error,
    error,
    refresh: mutate,
  };
}
